// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-CL_IMAGE_PATH-td {\n  text-align: center;\n}", "",{"version":3,"sources":["webpack://src/Components/ColorInfo/color.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF","sourcesContent":[".table-CL_IMAGE_PATH-td {\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
